import { toZonedTime, toDate, format as formatTz } from "date-fns-tz";
import { parseISO } from "date-fns";
import { enGB } from 'date-fns/locale/en-GB'
import { zoneFor } from "@components/ui/timezone/timezoneMappings";

/**
 * @category Utils
 */
export function toLocalISOString(date) {
    const tzOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(date - tzOffset).toISOString().slice(0, -1); // Remove the 'Z' at the end
    return localISOTime;
}

/**
 * @category Utils
 */
export const convertToLocalTime = (utcDateString, timezone) => {
    if (!utcDateString || !timezone) return "";

    try {
      // Parse the ISO-formatted UTC date string
      const utcDate = parseISO(utcDateString);

      // Alberta and BC timestamps from before 2026-03-08 convert under the old DST rules
      const zone = zoneFor(timezone, utcDate);

      // Convert the UTC date to the provided timezone
      const zonedDate = toZonedTime(utcDate, zone);

      // Format the date in the provided timezone using a custom pattern
      return formatTz(zonedDate, "yyyy-MM-dd HH:mm:ss", { timeZone: zone, locale: enGB });

    }catch(err){
      console.error("convertToLocalTime error:", err);
      return "";
    }
  }

/**
 * Turns a wall-clock string typed for a job, e.g. "2026-11-01T01:30:00", into the instant it
 * names in that job's zone. The string is first read at the zone's current offset to find roughly
 * when it falls, then re-read under the rules that were in force at that time, so a time typed
 * for January 2026 lands on the hour the clocks showed then.
 * @param {string} localDateTimeString ISO date and time with no offset
 * @param {string | {value: string}} timezone a timezoneMap entry or its zone string
 * @returns {Date}
 * @category Utils
 */
export const parseLocalTimeInTimezone = (localDateTimeString, timezone) => {
    const currentZone = typeof timezone === 'string' ? timezone : timezone.value;
    const atCurrentOffset = toDate(localDateTimeString, { timeZone: currentZone });
    const zone = zoneFor(timezone, atCurrentOffset);

    return zone === currentZone ? atCurrentOffset : toDate(localDateTimeString, { timeZone: zone });
}